angular.module 'zc.projects'

.controller 'SegmentShowCtrl', ($scope, $state, $translate, Page, currentProject, segment) ->
  Page.setBodyClass ''
  $translate('projectsSegments.controllers.show.segumento_shousai').then (translation) ->
    Page.setTitle translation

  $scope.project = currentProject
  $scope.segment = segment



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.segments/show.controller.coffee